import Header from './components/Header';
import Hero from './sections/Hero';
import About from './sections/About';
import ValueProposition from './sections/ValueProposition';
import Capabilities from './sections/Capabilities';
import CaseStudies from './sections/CaseStudies';
import Process from './sections/Process';
import Contact from './sections/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="app">
      <Header />
      <main>
        <Hero />
        <About />
        <ValueProposition />
        <Capabilities />
        <CaseStudies />
        <Process />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
